module.exports = __webpack_public_path__ + "images/brand-icons.46661d6d65debc63884004fed6e37e5c.svg";